import { render, staticRenderFns } from "./TrackComplaintStatus.vue?vue&type=template&id=4f6f476a&scoped=true&"
import script from "./TrackComplaintStatus.vue?vue&type=script&lang=js&"
export * from "./TrackComplaintStatus.vue?vue&type=script&lang=js&"
import style0 from "./TrackComplaintStatus.vue?vue&type=style&index=0&id=4f6f476a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6f476a",
  null
  
)

export default component.exports